<script type="text/jsx">
import UiButton from './UiButton.vue';

export default {
    functional: true,
    render(h, { children, data }) {
        data.class = { 'ui-row-btn clicked': true, ...data.class };
        return <UiButton {...data}>
            <div class="z-10">{children}</div>
        </UiButton>;
    },
};
</script>
<style lang="scss">
    @import 'common/scss/variables';
    @import '@/styles/colors/variables';
    @import 'common/scss/variables/spacing';
    @import 'common/scss/variables/curves';

    .ui-row-btn {
        position: relative;
        width: 100%;

        .content {
            z-index: 1;
            color: $elephant;
        }
        &.btn-ripple-wrap {
            overflow: hidden;
            .circle {
                content: "";
                @apply block rounded top-0 absolute h-full m-auto bg-light-gray border-none z-0;
                opacity: 0.3;
                animation: scale-effect 1.6s;
            }
        }

        @keyframes scale-effect {
            from {
                width: 0;
                background: $mouse;
                opacity: 1;
                transform: inherit;
                transform: scale(.2);
            }
            to {
                width: 100%;
                background: $light-gray;
                opacity: 0.3;
                transform: inherit;
                transform: scale(100);
            }
        }
    }

</style>
